import PickingForDeliveryDetail from '@/models/PickingForDelivery/PickingForDeliveryDetail';

export default class PickingForDeliveryDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.pickingForDeliveryId  = '';
		this.pickingForDeliveryPickingNumber = '';
		this.deliveryInstructionDetailId  = '';
		this.deliveryInstructionDetailPart = '';
		this.planQty = '';
		this.actualQty = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			pickingForDeliveryId : '0',
			pickingForDeliveryPickingNumber : '0',
			deliveryInstructionDetailId : '0',
			deliveryInstructionDetailPart : '0',
			planQty : '0',
			actualQty : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}